import { STATUS_CONFIG } from '@/configs/constants';
import { StatusType } from '@/types/enums';
import { useTranslation } from 'react-i18next';

interface StatusProps {
    status: StatusType | undefined
}

export default function Status({ status }: StatusProps) {
    // hooks
    const { t } = useTranslation();

    return (
        status !== undefined ?
            (
                <div className={`${STATUS_CONFIG[status].color}`}>
                    {t(`field.${STATUS_CONFIG[status].key}`)}
                </div>
            ) :
            (
                <></>
            )
    );
}
